<div class="container-fluid navbar-container g-0">
  <span style="position: absolute; top: 0; left: 0; font-size: 12px"
    >Version: {{ version }}</span
  >
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a
        class="navbar-brand"
        href="https://www.gov.ph/"
        target="_blank"
        style="color: #000; font-weight: 700"
        ><strong>GOVPH</strong></a
      >
      <a
        href="#"
        class="d-flex align-items-center col-md-6 col-lg-4 mb-2 mb-md-0 text-dark text-decoration-none"
      >
        <img
          src="assets/baguio-logo-gov.png"
          width="90px"
          height="90px"
          class="city-logo"
        />
        <div style="display: flex; flex-direction: column">
          <span class="city-government">Republic of the Philippines</span>
          <hr
            style="
              background-color: #198754;
              margin-top: 5px;
              margin-bottom: 5px;
            "
          />
          <span class="city-name"
            ><strong>City Government of Baguio</strong></span
          >
        </div>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="border-color: #198754"
      >
        <img src="/assets/menu.png" alt="" height="25px" width="25px" />
      </button>
      <div
        class="collapse navbar-collapse collapsed-navbar"
        id="navbarSupportedContent"
        style="padding: 1rem"
      >
        <div class="col-10 navbar-nav">
          <li class="li-nav">
            <a href="#" class="nav-menu p-3">Home</a>
          </li>
          <li class="li-nav">
            <a href="about-us" class="nav-menu p-3">About</a>
          </li>
          <li class="li-nav">
            <a href="services" class="nav-menu p-3">Services</a>
          </li>
          <li class="li-nav">
            <a href="contact-us" class="nav-menu p-3">Contact Us</a>
          </li>
        </div>
        <div class="navbar-nav ms-auto">
          <button
            *ngIf="workPASStokenExist == false"
            mat-raised-button
            color="primary"
            (click)="onNavigateLogin()"
            class="text-white"
          >
            Apply Now
          </button>
          <button
            *ngIf="workPASStokenExist == true"
            mat-raised-button
            color="primary"
            class="text-white"
            (click)="onNavigateDashboard()"
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  </nav>
</div>
<app-banner></app-banner>

<div class="container-fluid landing">
  <div class="row faq">
    <div class="col-lg-3">
      <div class="d-flex justify-content-center card-margin">
        <mat-card class="card-services" (click)="navigateServices()">
          <mat-card-content style="text-align: center; padding: 25px 30px">
            <img
              src="/assets/green-card.png"
              alt=""
              style="margin: 1rem auto"
            />
            <h3 class="mt-2">Green Card</h3>
            <mat-label>Non-Food Handler</mat-label>
            <h6 style="color: #05a34a; text-align: right" class="mt-3">
              See more >
            </h6>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="d-flex justify-content-center card-margin">
        <mat-card class="card-services" (click)="navigateServices()">
          <mat-card-content style="text-align: center; padding: 25px 30px">
            <img
              src="/assets/yellow-card.png"
              alt=""
              style="margin: 1rem auto"
            />
            <h3 class="mt-2">Yellow Card</h3>
            <mat-label>Food Handler</mat-label>
            <h6 style="color: #05a34a; text-align: right" class="mt-3">
              See more >
            </h6>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="d-flex justify-content-center card-margin">
        <mat-card class="card-services" (click)="navigateServices()">
          <mat-card-content style="text-align: center; padding: 25px 30px">
            <img src="/assets/pink-card.png" alt="" style="margin: 1rem auto" />
            <h3 class="mt-2">Pink Card</h3>
            <mat-label>Female Entertainer</mat-label>
            <h6 style="color: #05a34a; text-align: right" class="mt-3">
              See more >
            </h6>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="d-flex justify-content-center card-margin">
        <mat-card class="card-services" (click)="navigateServices()">
          <mat-card-content style="text-align: center; padding: 25px 30px">
            <img src="/assets/blue-card.png" alt="" style="margin: 1rem auto" />
            <h3 class="mt-2">Blue Card</h3>
            <mat-label>Male Entertainer</mat-label>
            <h6 style="color: #05a34a; text-align: right" class="mt-3">
              See more >
            </h6>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="row faq">
    <div class="col-12" style="padding: 1.5rem 0rem">
      <mat-card class="faq">
        <mat-card-header>
          <mat-card-title>Frequently Asked Questions</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon
                  aria-hidden="false"
                  class="mr-2"
                  style="color: #05a34a; margin-right: 1rem"
                >
                  work
                </mat-icon>
                <span class="desktop">Public Employment Services Office </span>
                <span class="mobile">PESO</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="faq-container">
              <p>
                <strong
                  >1. Q: What are the requirements of a working permit?
                </strong>
              </p>
              <p>A: The requirements are:</p>
              <ul style="margin: 0; padding-left: 20px; list-style-type: disc">
                <li>Community Tax Certificate (CTC)/ Cedula</li>
                <li>Working Permit Fee Receipt</li>
                <li>Police Clearance</li>
                <li>Working Permit Application Form</li>
                <li>Medical Test Application Form</li>
                <li>Medical Test Results (Updated)</li>
                <li>Health Card (Updated)</li>
                <li>
                  Certificate Of Food Handler Seminar (For Food Handlers Only)
                </li>
                <li>National Skills Registration Program Form</li>
                <strong>Additional Requirements:</strong>
                <li>
                  For Minors - Parent/Guardian's Letter of Consent and Valid Id
                </li>
                <li>Entertainer - Valid Id and Original Birth Certificate</li>
              </ul>
              <p>
                <strong>
                  2. Q: Where to pay Cedula, Police Clearance, Working Permit
                  Fee, Professional/Occupational Tax?
                </strong>
                <br />
              </p>
              <p>A: For Baguio Residents pay the following:</p>
              <ul style="margin-bottom: 0; padding-left: 20px">
                <li>Cedula</li>
                <li>Police Clearance</li>
                <li>Working Permit Fee</li>
                <li>Professional/Occupational Tax</li>
              </ul>
              <p>at the Baguio Treasury Office - Business-One-Stop-Shop.</p>

              <p>
                For Non-Baguio Residents pay or secure Cedula/CTC and
                Professional/Occupational Tax at your respective Municipal Hall
                and pay the Police Clearance, and Working Permit Fee at Baguio
                Treasury Office - Business-One-Stop-Shop
              </p>

              <p>
                <strong>
                  3. Q: Who should pay the special working permit fee?
                </strong>
              </p>
              <p>A: The following shall pay the special working permit fee:</p>
              <ul style="list-style: disc; padding-left: 20px">
                <li>Managers</li>
                <li>Supervisors</li>
                <li>Officers</li>
                <li>ESL Teachers</li>
                <li>BPO Agents</li>
                <li>Tourist Guides</li>
                <li>Massage Therapist</li>
                <li>Entertainers</li>
                <li>Physical Trainer/ Gym Instructor</li>
              </ul>
              <p>
                <strong
                  >4. Q: Who should pay the Professional/Occupational Tax?
                </strong>
              </p>
              <p>
                A: Licensed practicing professionals must pay for the
                professional/occupational tax.
              </p>
              <p>
                <strong>
                  5. Q: Validity of the Working Permit for non-food handlers
                </strong>
              </p>
              <p>
                A: The validity of the Working Permit for non-food handlers is
                one (1) year.
              </p>
              <p>
                <strong
                  >6. Q: Validity of the Working Permit for food handlers and
                  entertainers.</strong
                >
              </p>
              <p>
                A: The validity of the Working Permit for food handlers and
                entertainers is six (6) months.
              </p>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <img
                  src="/assets/heartbeat.png"
                  alt=""
                  srcset=""
                  style="margin-right: 1rem"
                />

                <span class="desktop">Health Services Office </span>
                <span class="mobile">HSO</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="faq-container">
              <p>
                <strong>
                  1. Q: Who is required to secure a Health Certificate (HC)?
                </strong>
              </p>
              <p>
                A: All employees working in Food Establishments including
                Non-Food Establishments working in;
              </p>
              <ul style="list-style: disc; padding-left: 20px">
                <li>
                  Tonsorial or Beauty Establishments (eg.: barber shop, beauty
                  parlor, hairdressing, manicuring, figure slending, and the
                  like)
                </li>
                <li>Hotels, Inns and Lodging Houses</li>
                <li>Spas, Massage and Saunas</li>
                <li>Private teachers, tutorials, ESL</li>
                <li>Pest Control</li>
                <li>Tourist Guides</li>
                <li>Golf Caddies</li>
                <li>Septage Haulers - puso negro</li>
                <li>Security Guards</li>
              </ul>
              <p>
                <strong>
                  2. Q: What are the requirements for securing Health
                  Certificates?
                </strong>
              </p>
              <p>
                A: Laboratory Results on Stool Analysis (1 month validity) and
                Chest X-ray (6-months). 2pcs inx1in ID picture and 1pc 2x2 (for
                work permit).
              </p>
              <p>
                <strong>
                  3. Q: Does the HSO have a laboratory to do these tests?
                </strong>
              </p>
              <p>
                A: Yes, and they are open from 8:00AM to 11:00AM (on a first
                come, first served basis)
              </p>
              <p>
                <strong>
                  4. Q: How much does it cost for me to secure my HC?
                </strong>
              </p>
              <p>
                A: Php 25.00 (for the HC) and Php100.00 for the lab tests (stool
                and x-ray).
              </p>
              <p>
                <strong>
                  5. Q: Could I have my lab tests done outside the HSO Lab?
                </strong>
              </p>
              <p>
                A: Yes, just bring the test results and present it at the HSO.
              </p>
              <p>
                <strong>
                  6. Q: Who is required to undergo a Food Handler's
                  Seminar/Orientation?
                </strong>
              </p>
              <p>
                A: Any person/worker who handles, stores, prepares, serves food,
                drinks or ice or who comes in contact with any eating or cooking
                utensils and food vending machines.
              </p>
              <p>
                <strong>
                  7. Q: What is the schedule for the Food Handler's Seminar?
                </strong>
              </p>
              <p>
                A: The HSO conducts daily (Mondays to Fridays, except holidays)
                FH Seminar, starting at 8:00AM (late comers will not be allowed
                to enter).
              </p>
              <p>
                <strong>
                  8. Q: How often do I need to attend the Food Handler Seminar?
                </strong>
              </p>
              <p>A: Food Handler Seminar is valid for three (3) years.</p>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <img
                  src="/assets/police-station.png"
                  alt=""
                  srcset=""
                  style="margin-right: 1rem"
                />

                <span class="desktop">Baguio City Police Office </span>
                <span class="mobile">BCPO</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="faq-container">
              <p>
                <strong> 1. Q: Requirements for police clearance? </strong>
              </p>
              <p>
                1. A: Cedula, Police Clearance Receipt, Court Clearance if with
                hit/record and (2) valid IDs.
              </p>
              <p>
                <strong>2. Q: What if I only have one Valid ID? </strong>
              </p>
              <p>
                A: If you only have one valid ID, you can bring it along with a
                certified true copy of your birth certificate from PSA (with the
                original official receipt attached).
              </p>
              <p>
                <strong> 3. Q: Where to pay the Police Clearance? </strong>
              </p>
              <p>A: Pay at One Stop Shop.</p>
              <p>
                <strong> 4. Q: Do I have to acquire court clearance? </strong>
              </p>
              <p>A: Yes, only if you you have a hit/record.</p>
              <p>
                <strong>
                  5. Q;How long is the validity of Police Clearance?
                </strong>
              </p>
              <p>A: 6 months.</p>
              <p>
                <strong> 6. Q: Is personal appearance required? </strong>
              </p>
              <p>A: Yes, personal appearance is required.</p>
            </div>
          </mat-expansion-panel>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row faq" style="padding-bottom: 2rem">
    <div class="col-12">
      <mat-card class="faq" style="margin: 0px">
        <mat-card-header>
          <mat-card-title>Ordinances</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul style="list-style: none">
            <li>
              <a href="/assets/TAX ORDINANCE-2000-001.pdf" target="_blank"
                >Tax Ordinance 2000-001</a
              >
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<app-footer></app-footer>
